/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Hidden,
  makeStyles,
  Typography,
  Grid,
  Switch,
  FormControlLabel,
  Button,
  Divider,
} from '@material-ui/core';
import MotorcycleRentalSkeleton from 'views/motorcycle_rental/MotorcycleRentalSkeleton';
import WidgetSkeleton from 'views/motorcycle_rental/components/widget/WidgetSkeleton';
import GeoWidgetAndFilters from 'views/motorcycle_rental/components/GeoWidgetAndFilters';
import MapFiltersBtns from 'views/motorcycle_rental/components/MapFiltersBtns';
import { MapSection } from 'views/motorcycle_rental/components/MapSection/MapSection';
import { MapSectionSkeleton } from 'views/motorcycle_rental/components/MapSection/MapSectionSkeleton';
import {
  ERHoldingSection,
  ERHoldingSectionSkeleton,
} from 'views/motorcycle_rental/components/ERHoldingSection';
import { LinksGroupSectionSkeleton } from 'views/motorcycle_rental/components/LinksGroupSection';
import NearbyRentalsWrapper from 'views/motorcycle_rental/components/NearbyRentalsWrapper';
import BikeCard from 'common/components/bike_card/BikeCard';
import Breadcrumbs from 'common/components/breadcrumbs/Breadcrumbs';
import Typography500 from 'common/components/Typography500';
import ERPagination from 'components/ERPagination';
import MapIcon from '@material-ui/icons/Map';
import useHandleResponse from 'utils/useHandleResponse';
import removeKeysWithValue from 'utils/removeKeysWithValue';
import axios, { API } from 'config/axios';
import Head from 'next/head';
import generateMetaData from 'utils/generateMetaData';
import { withTranslation, Router } from 'config/i18n';
import Dinero from 'utils/Dinero';
import {
  initPageParams,
  getNewParam,
  geoPath,
  moneyFormat,
  getCurrentParams,
  appendQuery,
} from 'views/motorcycle_rental/utils/helpers';
import MainWidgetDialog from 'common/components/MainWidgetDialog/MainWidgetDialog';
import dayjs from 'dayjs';
import { PLACE_TYPES } from 'views/motorcycle_rental/utils/constants';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey['50'],
  },
  mapWrapper: {
    width: '33.3333333333%',
    height: 'calc(100vh - 8.375rem)',
    minHeight: 'calc(100vh - 8.375rem)',
    position: 'sticky',
    top: theme.spacing(10),
  },
  cardsWrapper: {
    flex: 1,
    padding: theme.spacing(2),
    maxWidth: '100%',
  },
  cardsWrapperContent: {
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  emptyBike: {
    width: theme.spacing(22),
    display: 'block',
    margin: 'auto',
  },
  noRentals: {
    color: theme.palette.grey['300'],
    textAlign: 'center',
    marginTop: theme.spacing(3),
  },
  clearFilter: {
    textDecoration: 'underline',
    color: theme.palette.primary.main,
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'none',
    },
  },
  mapIcon: {
    color: theme.palette.grey['300'],
    width: theme.spacing(2.5),
  },
  showMapSwitch: {
    marginLeft: theme.spacing(1),
    whiteSpace: 'nowrap',
    '& .MuiFormControlLabel-label': {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  NearbyRentalsWrapper: {
    backgroundColor: theme.palette.grey[50],
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  geoDescWrapper: {
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(0, 3, 4.5, 3),
  },
  geoDescTitle: {
    padding: theme.spacing(5, 0, 2, 0),
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(32),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(26),
    },
  },
  geoDescDescription: {
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(23),
    },
  },
}));

const getDayjsDate = (date) => date && dayjs(date, 'YYYY-MM-DD');

const MotorcycleRental = (props) => {
  const {
    t, serverData, slugData, ssrRender, hreflangData,
  } = props;
  const classes = useStyles();
  const { handleError } = useHandleResponse();

  // states
  const [rentalData, setRentalData] = useState(serverData);
  const [slugsData, setSlugsData] = useState(slugData);
  const [is302Req, setis302Req] = useState(false);
  const [showMap, setShowMap] = useState(!ssrRender);
  const [renderSkeleton, setRenderSkeleton] = useState(!ssrRender);
  const [widgetDialog, setWidgetDialog] = useState({ open: false });
  const [filtersModalOpen, setFiltersModalOpen] = useState(false);

  const isNearbyPlace = useMemo(() => {
    if (
      [PLACE_TYPES.AIRPORT, PLACE_TYPES.GEOGRAPHY, PLACE_TYPES.zipcode].includes(
        rentalData?.selected_filters.pickup_place?.placeable.type,
      )
    ) {
      return true;
    }
    // current location
    if (rentalData?.selected_filters.pickup_place?.id === null) {
      return true;
    }
    return false;
  }, [rentalData]);

  const getInOrNear = () => (isNearbyPlace ? 'near' : 'in');

  // handlers
  const toggleMap = () => {
    setShowMap(!showMap);
  };
  const handleFilterDialogOpen = () => {
    setFiltersModalOpen(true);
  };
  const handleFilterDialogClose = () => {
    setFiltersModalOpen(false);
  };
  const handleBikeCardClick = (bike) => {
    if (bike.host?.type !== 'location') {
      // not an eaglerider bike
      const url = `/${bike.vehicle_make.slug}/${bike.vehicle_model.slug}/${bike.host.geography.slug}/${bike.id}`;

      const { selected_filters: { pickup_date, dropoff_date } = {} } = rentalData || {};
      const dateQuery = { pickup_date, dropoff_date };
      Router.push(appendQuery(url, removeKeysWithValue(dateQuery, null)));
      return;
    }
    setWidgetDialog({
      open: true,
      data: {
        pickup_location_id: bike.host?.id,
        dropoff_location_id: rentalData?.selected_filters?.dropoff_location?.id || bike.host?.id,
        vehicle_model_id: bike.id,
        pickup_date: getDayjsDate(rentalData?.selected_filters?.pickup_date),
        dropoff_date: getDayjsDate(rentalData?.selected_filters?.dropoff_date),
        reservation_type_id: 1,
      },
      bikeData: {
        name: `${bike.vehicle_make.name} ${bike.vehicle_model.name}`,
        image: bike.image_url,
      },
    });
  };
  const handleWidgetClose = () => {
    setWidgetDialog({ open: false });
  };
  const navigateToNewParams = (params) => {
    const {
      pickup_place_slug,
      dropoff_location_id,
      vehicle_make_slug,
      vehicle_model_slug,
      vehicle_type_slug,
      pickup_date,
      dropoff_date,
      page,
      lat,
      lng,
    } = params;
    const defaultListTypeSlug = t('routes:motorcycle-rental');
    const useMotorcycleSegmentWithVehicleTypeQuery = Boolean(
      pickup_place_slug
        && vehicle_type_slug
        && vehicle_type_slug !== defaultListTypeSlug
        && !vehicle_make_slug
        && !vehicle_model_slug,
    );

    const queryParams = {};
    Object.entries({
      dropoff_geography_id: dropoff_location_id,
      pickup_date,
      dropoff_date,
      page,
      lat,
      lng,
      ...(useMotorcycleSegmentWithVehicleTypeQuery ? { vehicle_type_slug } : {}),
    }).forEach(([key, value]) => {
      if (value) queryParams[key] = value;
    });

    let geoUrl;
    let slug1;
    let slug2;
    let slug3;
    if (useMotorcycleSegmentWithVehicleTypeQuery) {
      geoUrl = geoPath([defaultListTypeSlug, pickup_place_slug]);
      slug1 = defaultListTypeSlug;
      slug2 = pickup_place_slug;
      slug3 = undefined;
    } else {
      geoUrl = geoPath([
        vehicle_make_slug,
        vehicle_type_slug,
        vehicle_model_slug,
        pickup_place_slug,
      ]);
      slug1 = vehicle_make_slug || vehicle_type_slug;
      slug2 = vehicle_model_slug;
      slug3 = pickup_place_slug;
    }

    Router.push(
      {
        pathname: '/geo',
        query: {
          slug_1: slug1,
          slug_2: slug2,
          slug_3: slug3,
          ...queryParams,
        },
      },
      appendQuery(geoUrl, queryParams),
    );
  };

  const handleFieldChange = (newParam) => {
    const params = { ...getCurrentParams(rentalData), ...newParam };
    navigateToNewParams(params);
  };
  const handleClearAllFilters = () => {
    handleFieldChange({
      vehicle_type_slug: t('routes:motorcycle-rental'),
      vehicle_make_slug: null,
      vehicle_model_slug: null,
      pickup_place_slug: null,
      dropoff_location_id: null,
      lat: null,
      lng: null,
      pickup_date: null,
      dropoff_date: null,
      page: null,
    });
  };
  const handlePaginationClick = (page) => {
    handleFieldChange({ page });
  };

  const getRentalData = (params) => {
    setRenderSkeleton(true);
    return axios
      .get(API.geo.rentals, { params })
      .then((res) => {
        setRentalData(res.data);
        setis302Req(false);
        setRenderSkeleton(false);
        return res.data;
      })
      .catch((err) => {
        switch (err.response?.status) {
          case 302:
            if (err.response.data.error_code === 'ERR002') {
              const newParams = {
                ...initPageParams(slugsData),
                ...getNewParam(err.response.data),
              };
              navigateToNewParams(newParams);
              setis302Req(true);
            }
            break;

          default:
            setis302Req(false);
            handleError(err);
            break;
        }
      });
  };

  const getBikeStatus = (bike) => {
    const status = {};
    const { pickup_date, dropoff_date, pickup_place } = rentalData?.selected_filters;
    if (pickup_place?.id && dropoff_date && pickup_date) {
      if (bike.availability) {
        if (bike.availability.count != null) {
          const { count } = bike.availability;
          if (count > 0) {
            status.availableCount = count;
            return status;
          }
          status.soldout = true;
          return status;
        }
        if (bike.availability.status == 'tentative') {
          status.tentative = true;
          return status;
        }
      }
    }
    if (bike.value_deal) {
      status.valueDeal = true;
      return status;
    }
    return {};
  };
  const preparedBikes = useMemo(
    () => rentalData?.rentals?.map((bike) => {
      const status = getBikeStatus(bike);
      return {
        id: bike.id,
        region: {
          name: `${bike.host?.geography?.name || bike.host.city_name}, ${
            bike.host?.region?.name || bike.host?.country?.name
          }`,
        },
        vehicle_make: bike.vehicle_make,
        vehicle_model: bike.vehicle_model,
        image_path: bike.image_url,
        price: bike.price.rate_per_day ? moneyFormat(Dinero(bike.price.rate_per_day)) : null,
        hourly_price: bike.price.rate_per_hour
          ? moneyFormat(Dinero(bike.price.rate_per_hour))
          : null,
        owner: bike.host.type === 'owner',
        renter: {
          id: bike.host.id,
          type: bike.host.type,
          name: bike.host.name,
        },
        ...status,
        url:
            bike.host
            && bike.host.type !== 'location'
            && bike.vehicle_make?.slug
            && bike.vehicle_model?.slug
            && bike.host.geography?.slug
              ? `/${bike.vehicle_make.slug}/${bike.vehicle_model.slug}/${bike.host.geography.slug}/${bike.id}`
              : null,
        onClick: () => {
          handleBikeCardClick(bike);
        },
      };
    }),
    [rentalData],
  );
  const pagingData = useMemo(
    () => ({
      active_page: rentalData?.pagination?.current_page,
      pages_count: rentalData?.pagination?.pages_count,
    }),
    [rentalData],
  );

  const preparePageTitleProps = () => {
    if (!rentalData?.selected_filters) return {};
    const {
      vehicle_make, vehicle_model, vehicle_type, pickup_place,
    } = rentalData.selected_filters;
    let title = null;
    if (!vehicle_make && !vehicle_model && !vehicle_type) {
      if (!pickup_place) {
        title = `${t('fe_es_geo_page:all')} ${t('fe_es_geo_page:index.header.eaglerider_rentals')}`;
      } else {
        title = `${t('fe_es_geo_page:all_rentals')} ${t(`fe_es_geo_page:${getInOrNear()}`)} ${
          pickup_place.name
        }`;
      }
    } else {
      title = `${vehicle_make ? vehicle_make.name : ''}
               ${vehicle_model ? vehicle_model.name : ''}
               ${vehicle_type ? vehicle_type.name : ''}
               ${t('fe_es_geo_page:rentals')}
               ${
  pickup_place ? `${t(`fe_es_geo_page:${getInOrNear()}`)} ${pickup_place.name}` : ''
}`;
    }
    let subTitle = rentalData?.total_count;
    if (vehicle_model) {
      subTitle += ` ${vehicle_model.name}
                  ${t('fe_es_geo_page:index.header.available_for_rent')}
                  ${
  pickup_place
    ? `${t(`fe_es_geo_page:${getInOrNear()}`)} ${pickup_place.name}`
    : ''
}`;
    } else {
      subTitle += ` ${vehicle_make ? vehicle_make.name : ''}
                  ${vehicle_type ? vehicle_type.name : ''}
                  ${t('fe_es_geo_page:index.header.available_for_rent')}
                  ${
  pickup_place
    ? `${t(`fe_es_geo_page:${getInOrNear()}`)} ${pickup_place.name}`
    : ''
}`;
    }
    const defaultTypeSlug = 'motorcycle-rental';
    const breadCrumbLinks = [
      vehicle_type && {
        text: vehicle_type.slug ? vehicle_type.slug.split('-').join(' ') : '',
        path: geoPath([vehicle_type?.slug]),
      },
      pickup_place?.country && {
        text: pickup_place.country.name,
        path: geoPath([vehicle_type?.slug || defaultTypeSlug, pickup_place?.country?.slug]),
      },
      pickup_place?.region && {
        text: pickup_place.region.name,
        path: geoPath([vehicle_type?.slug || defaultTypeSlug, pickup_place.region.slug]),
      },
      pickup_place
        && pickup_place.placeable.type != 'country'
        && pickup_place.placeable.type != 'region' && {
        text: pickup_place.name,
        path: geoPath([vehicle_type?.slug || defaultTypeSlug, pickup_place.slug]),
      },
      vehicle_make && {
        text: vehicle_make.name,
        path: geoPath([vehicle_make?.slug, pickup_place?.slug]),
      },
      vehicle_model && {
        text: vehicle_model.name,
        path: '',
      },
    ].filter((item) => !!item);
    const lastBreadCrumbItem = breadCrumbLinks.pop();
    return {
      pageTitle: {
        title,
        subTitle,
      },
      breadcrumbsObject: {
        links: [...breadCrumbLinks],
        breadCrumbsTitle: lastBreadCrumbItem?.text,
      },
    };
  };

  useEffect(() => {
    if (!serverData) {
      const params = initPageParams(slugsData);
      if (!params) {
        setRenderSkeleton(true);
        return;
      }
      getRentalData(params);
    }
  }, []);
  useEffect(() => {
    if (serverData) return;
    if (rentalData || is302Req) {
      const params = initPageParams(slugsData);
      getRentalData(params);
    }
  }, [slugsData]);
  useEffect(() => {
    setSlugsData(slugData);
  }, [slugData]);

  const renderSSRCanonicalLinks = () => (
    <>
      <link rel="canonical" href={hreflangData.canonical} />
      {hreflangData.urls.map((local) => (
        <link key={local.hreflang} rel="alternate" href={local.url} hrefLang={local.hreflang} />
      ))}
    </>
  );

  const getGeoDescriptionProps = () => ({
    make: `${
      rentalData.selected_filters.vehicle_make?.name
        ? `${rentalData.selected_filters.vehicle_make?.name} `
        : ''
    }`,
    type:
      rentalData.selected_filters.vehicle_type?.name || t('fe_es_geo_page:index.motorcycle.one'),

    location: rentalData.selected_filters.pickup_place?.name
      ? rentalData.selected_filters.pickup_place?.name
      : '',
  });

  const getGeoDescription = (type) => {
    const descriptionProps = getGeoDescriptionProps();
    if (descriptionProps.location === '') {
      return type === 'title'
        ? t('fe_es_geo_page:description_title', { ...descriptionProps })
        : t('fe_es_geo_page:looking_to_rent', { ...descriptionProps });
    }
    return type === 'title'
      ? t(`fe_es_geo_page:description_title_${getInOrNear()}_location`, { ...descriptionProps })
      : t(`fe_es_geo_page:looking_to_rent_${getInOrNear()}_locations`, { ...descriptionProps });
  };

  return (
    <>
      <Head>
        {rentalData?.seo_values && generateMetaData(rentalData.seo_values)}
        {typeof window === 'undefined' && hreflangData && renderSSRCanonicalLinks()}
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(rentalData?.structured_data),
          }}
        />
      </Head>
      {rentalData ? (
        <GeoWidgetAndFilters
          rentalData={rentalData}
          handleFieldChange={handleFieldChange}
          translatedType={t('routes:motorcycle-rental')}
        />
      ) : (
        <WidgetSkeleton />
      )}

      <Box display="flex" className={classes.root}>
        {renderSkeleton ? (
          <MotorcycleRentalSkeleton />
        ) : (
          <Box className={classes.cardsWrapper}>
            <Box
              className={classes.cardsWrapperContent}
              display="flex"
              justifyContent="space-between"
              alignItems="start"
            >
              {rentalData && (
                <Box>
                  <Box mb={0.75}>
                    <Typography500 variant="h3" component="h1">
                      {preparePageTitleProps().pageTitle?.title}
                    </Typography500>
                  </Box>

                  <Typography component="h2" variant="h6">
                    {preparePageTitleProps().pageTitle?.subTitle}
                  </Typography>

                  <Box mb={1}>
                    <Breadcrumbs data={preparePageTitleProps().breadcrumbsObject} />
                  </Box>
                </Box>
              )}
              <Hidden mdDown>
                <Box display="flex" alignItems="center" ml={4}>
                  <MapIcon className={classes.mapIcon} />
                  <FormControlLabel
                    className={classes.showMapSwitch}
                    labelPlacement="start"
                    label={t('fe_geo_filters:show_map')}
                    control={(
                      <Switch
                        checked={showMap}
                        onChange={toggleMap}
                        name="showMap"
                        color="primary"
                      />
                    )}
                  />
                </Box>
              </Hidden>
            </Box>

            <Grid container spacing={2}>
              {preparedBikes?.map((bike, index) => (
                <Grid key={bike.id} item xs={12} md={6} lg={showMap ? 4 : 3} xl={showMap ? 4 : 3}>
                  <BikeCard bike={bike} priorityImg={index < 2} />
                </Grid>
              ))}
            </Grid>

            {pagingData?.pages_count > 1 && (
              <Box mt={4}>
                <ERPagination
                  data={pagingData}
                  url={pagingData.url}
                  link={pagingData.link}
                  handleChange={handlePaginationClick}
                />
              </Box>
            )}

            {rentalData?.rentals?.length <= 0 && (
              <Box my={12}>
                <img src="/imgs/geo_empty_bike.webp" alt="" className={classes.emptyBike} />
                <Box>
                  <Typography variant="h5" className={classes.noRentals}>
                    {t('fe_es_geo_page:no_rentals')}
                    <Button
                      onClick={handleClearAllFilters}
                      variant="text"
                      className={classes.clearFilter}
                    >
                      {t('fe_es_geo_page:clear_filters')}
                    </Button>
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        )}

        <Hidden mdDown>
          {showMap && (
            <Box className={classes.mapWrapper}>
              {rentalData ? (
                <MapSection
                  rentals={rentalData?.rentals}
                  selectedPlace={rentalData?.selected_filters.pickup_place}
                  handleClose={toggleMap}
                  handleBikeCardClick={handleBikeCardClick}
                />
              ) : (
                <MapSectionSkeleton />
              )}
            </Box>
          )}
        </Hidden>
      </Box>

      <Divider />
      <Box pt={6} className={classes.NearbyRentalsWrapper}>
        {renderSkeleton ? (
          <LinksGroupSectionSkeleton />
        ) : (
          <NearbyRentalsWrapper
            nearbyRentals={rentalData?.nearby_rentals}
            handleNearByLinkClick={() => {}}
            ssrRender={ssrRender}
          />
        )}
      </Box>

      {rentalData && (
        <Box className={classes.geoDescWrapper}>
          <Divider />
          <Typography
            variant="h3"
            component="h4"
            className={classes.geoDescTitle}
            dangerouslySetInnerHTML={{
              __html: getGeoDescription('title'),
            }}
          />
          <Typography
            variant="body1"
            className={classes.geoDescDescription}
            dangerouslySetInnerHTML={{
              __html: getGeoDescription('body'),
            }}
          />
        </Box>
      )}
      {renderSkeleton ? <ERHoldingSectionSkeleton /> : <ERHoldingSection />}
      {!ssrRender && (
        <Hidden lgUp>
          <MapFiltersBtns
            isWidgetOpen={widgetDialog.open}
            rentalData={rentalData}
            filtersModalOpen={filtersModalOpen}
            handleFilterDialogOpen={handleFilterDialogOpen}
            handleFilterDialogClose={handleFilterDialogClose}
            handleFieldChange={handleFieldChange}
            handleClearAllFilters={handleClearAllFilters}
            selectedPlace={rentalData?.selected_filters.pickup_place}
            handleBikeCardClick={handleBikeCardClick}
          />
        </Hidden>
      )}
      {widgetDialog.open && (
        <MainWidgetDialog
          open={widgetDialog.open}
          handleClose={handleWidgetClose}
          reservationData={widgetDialog.data}
          floatingDialog
          announcementBar
          renderFullWidgetByForce
          fixPosition
          shouldHideTitle
          bikeName={widgetDialog.bikeData.name}
          image={{
            src: widgetDialog.bikeData.image,
            alt: widgetDialog.bikeData.name,
          }}
        />
      )}
    </>
  );
};

export default withTranslation(['fe_es_geo_page', 'routes'])(MotorcycleRental);
